import React from 'react';
import { Alert, Flex, Typography, theme } from 'antd';

import CopyableValue from './CopyableValue';

const { Paragraph, Text } = Typography;

// FIXME: no exact token — the design's 420px nameserver boxes.
const NAMESERVER_WIDTH = 420;

export type CloudflareNameserverPairProps = {
  /** Cloudflare assigns every zone a pair, so an empty list means the fetch failed. */
  nameservers: readonly string[];
  withRegistrarInstruction?: boolean;
};

const CloudflareNameserverPair = ({
  nameservers,
  withRegistrarInstruction = false,
}: CloudflareNameserverPairProps) => {
  const { token } = theme.useToken();

  if (nameservers.length === 0) {
    return (
      <Alert
        type="warning"
        showIcon
        message="We couldn't retrieve your nameservers automatically. Find them in your Cloudflare dashboard under DNS → Settings → Cloudflare Nameservers"
      />
    );
  }

  return (
    <Flex vertical align="center" gap={token.marginMD}>
      {withRegistrarInstruction && (
        <Paragraph
          style={{
            marginBottom: 0,
            textAlign: 'center',
            fontSize: token.fontSizeSM,
            color: token.colorTextQuaternary,
          }}
        >
          Log in to your registrar (e.g. GoDaddy, Namecheap),
          <br />
          find DNS settings, and replace your current nameservers with the following:
        </Paragraph>
      )}
      {nameservers.map((nameserver, index) => (
        <Flex
          key={nameserver}
          justify="space-between"
          align="center"
          gap={token.marginXS}
          style={{
            width: '100%',
            maxWidth: NAMESERVER_WIDTH,
            padding: token.padding,
            background: token.colorFillAlter,
            border: `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`,
            borderRadius: token.borderRadiusLG,
          }}
        >
          <Text>Nameserver #{index + 1}</Text>
          <CopyableValue value={nameserver} variant="inline" />
        </Flex>
      ))}
    </Flex>
  );
};

export default CloudflareNameserverPair;
